<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Header-->
    <header-component :headerTitle="headerText" />
    <v-snackbar
      v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <!-- seacrh, action button and filter -->
    <v-card class="v-card-100">
      <v-card-title style="padding:28px" class="action-style pb-0">
        <!-- Search fields -->
        <v-row class="ma-1">
          <v-autocomplete v-model="select_field" :items="select_field_items" item-title="name" item-value="value" label="Select Field" variant="outlined" style="max-width: 158px;" class="mr-4"> </v-autocomplete>
          <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" v-no-edge-space label="Search" style="max-width: 270px;" variant="outlined" v-on:keyup.enter="getData('search')" :disabled="!select_field"></v-text-field>
          <v-spacer></v-spacer>
          <v-card-actions style="margin-top: -30px;">
            <v-btn class="mr-2 text-none" variant="flat" @click="downloadFile" color="primary" large style="min-height:55px; min-width:130px; font-weight:600;">Download</v-btn>
            <v-btn class="mr-2 text-none" variant="flat" :disabled="selected.length === 1" @click="navigateToFileUpload" color="primary" large style="min-height:55px; min-width:100px; font-weight:600;">Upload</v-btn>
          </v-card-actions>
          <!-- Filter -->
          <!-- <v-expansion-panels class="custom-control_outlined" ref="filterPopupRef" readonly style="max-width: 110px; margin-bottom: 28px; min-height: 56px;">
          <v-expansion-panel outlined @click="filterListOfButtons" >
            <v-expansion-panel-header>Filter
              <template v-slot:actions>
                <v-icon color="primary">
                  mdi-menu-down
                </v-icon>
              </template>
          </v-expansion-panel-header>
          </v-expansion-panel>
          </v-expansion-panels> -->
        </v-row>
      </v-card-title>
    </v-card>
    <!-- tabs data -->
    <v-layout column>
      <!-- <v-flex md6 style="overflow: auto"> -->
        <v-data-table 
           density="compact"
           :dense="true" 
           :search="search" 
           v-model="selected" 
           show-select disable-pagination
           :hide-default-footer="true" 
           :headers="headers" 
           :items="table_data" 
           return-object
           :loading="loading" fixed-header
           height="100%" 
          :items-per-page="pageSize"
           loading-text="Loading Data... Please wait" class="elevation-1">
           <template v-slot:[`item.${headers.key}`]="{ item }" v-for="headers in headers">
              <span v-if="headers.key !== 'imags' && item[headers.key]">
                <span v-tooltip="item[headers.key]">
                  {{ item[headers.key].length > 20 ? item[headers.key].slice(0, 20) + '...' : item[headers.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>
          <!-- <template v-for="(header, index) in headers" :key="index" v-slot:[`item.${header.key}`]="{ item }">
            <span v-if="item[header.key] !== null && item[header.key] !== ''">
              {{ item[header.key] }}
            </span>
            <span v-else>
              <span>-</span>
            </span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
      <!-- </v-flex> -->
    </v-layout>
    <!-- pagination display -->
           <div>
                <v-row class="ml-2 pb-4">
                    <span class="PaddingItemPerPage d-flex mt-4">
                        <label class="" style="margin-top: -2px;">Rows Per Page</label>
                        <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange"
                        variant="outlined" density="compact" style="margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
                    </span>
                    <span class="item-selected" :style="this.totalCount > 9999 ? 'left:24% !important;' : ''"> <span v-if="selected.length == 1">{{ selected.length }} Item Selected</span> <span
                        v-if="selected.length > 1">{{ selected.length }} Items Selected</span> </span>
                    <v-spacer></v-spacer>
                    <div class="d-flex">
                        <span :class="this.totalCount > 9999 ? 'pt-2 mt-3 mr-1' : 'pt-2 mt-3 mr-1'" v-if="this.totalCount > 0">Showing Results {{ (this.page - 1) * this.pageSize + 1 }}
                        - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}</span>
                        <span class="PaddingItemPerPage mr-3" :style="totalPages>7 ? 'min-width: 380px' : 'auto'">
                        <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
                        @update:modelValue="handlePageChange" density="compact" rounded="circle"></v-pagination>
                        </span>
                    </div>
                </v-row>
            </div>
  </v-card>
</template>
<script>
import HeaderComponent from "../../../../commoncomponents/HeaderComponent.vue";
export default {
  components: {
    HeaderComponent
  },
  data() {
    return {
      headerText: "Approval Matrix",
      alert: false,
      alert_type: "success",
      alert_message: "",
      search_tag: "",
      loading: false,
      selected: [],
      headers: [
        { title: "Approval Type", key: "approval_type", minWidth: "200px" },
        { title: "Rule", key: "rule", minWidth: "150px" },
        { title: "Initiator Email ID", key: "initiator", minWidth: "200px" },
        { title: "Approver 1 Email ID", key: "Approver 1", minWidth: "200px" },
        { title: "Escalation TAT (Hr)", key: "Escalation TAT 1", minWidth: "200px" },
        { title: "Approver 2 Email ID", key: "Approver 2", minWidth: "200px" },
        { title: "Escalation TAT (Hr)", key: "Escalation TAT 2", minWidth: "200px" },
        { title: "All or Any", key: "All or Any 2", minWidth: "200px" },
        { title: "Approver 3 Email ID", key: "Approver 3", minWidth: "200px" },
        { title: "Escalation TAT (Hr)", key: "Escalation TAT 3", minWidth: "200px" },
        { title: "All or Any", key: "All or Any 3", minWidth: "200px" },
        // { title: "Approver 4 Email ID", key: "org_name" },
        // { title: "Escalation TAT (Hr)", key: "org_name" },
        // { title: "All or Any", key: "org_name", width: "150px" },
        // { title: "Approver 5 Email ID", key: "org_name" },
        // { title: "Escalation TAT (Hr)", key: "org_name" },
        // { title: "All or Any", key: "org_name", width: "150px" },
        // { title: "Approver 6 Email ID", key: "org_name" },
        // { title: "Escalation TAT (Hr", key: "org_name" },
        // { title: "All or Any", key: "org_name", width: "150px" }
      ],
      table_data: [],
      search: "",
      number: 0,
      page: 1,
      totalPages: 1,
      totalCount: "",
      pageSize: 100,
      pageSizes: [100, 200, 500],
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: "top",
        text: null,
        timeout: 7500,
        title: null,
        visible: false
      },
      select_field_items: [
        {"name":"Initiator Email ID", "value":"Initiator"},
        {"name":"Approver 1 Email ID", "value":"Approver 1"},
        {"name":"Approver 2 Email ID", "value":"Approver 2"},
        {"name":"Approver 3 Email ID", "value":"Approver 3"}
      ],
      select_field: null,
      snackbar: false,
      headerTextSub: '',
      downloadDialog: false,
      emailError: '',
      email_id: '',
      isEmailValid: true,
    };
  },
  created() {
    this.headerTextSub = this.$store.state.inventoryId;
    this.getData();
    if(this.headerTextSub === 'success'){
      this.snackbar = true;
    }
  },
  computed: {
    emailRules() {
      return [
        v => this.emailError || true
      ];
    }
  },
  methods: {
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.scrollToTop();
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    getData(value) {
      this.loading = true;
      const params = {
        page: this.page,
        per_page: this.pageSize,
        key: this.select_field,
        value:this.search_tag
      };
      this.$httpSecured
        .get("/api/v2/approval_matrix", { params: params })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.approval_matrices.map(item => {
              const { approval_details } = item;
              return {
                ...item,
                ...approval_details,
              }
            });
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.$store.commit("setActiveTab", {});
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
        });
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.getData();
    },
    handlePageChange(value) {
      this.page = value;
      this.getData();
    },
    downloadFile() {
      this.number++;
      const formData = new FormData();
      const ids = this.selected.map(item => item.id);
      ids.forEach(id => formData.append("ids[]", id));
      let url;
      url = "/api/v2/approval_matrix/download";
      this.$httpSecured
        .post(url, formData)
        .then(response => {
          if (response.data) {
            const url = response.data.url;
            const link = document.createElement("a");
            link.href = url;
            link.download = "";
            document.body.appendChild(link);
            link.click();
            this.snackbar = {
              color: "success",
              icon: "mdi-check-circle",
              mode: "multi-line",
              position: "top",
              timeout: 3000,
              title: "Success",
              text: "(CSV File) Downloaded Successfully",
              visible: true
            };
            this.selected = [];
            this.number = 0;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
          this.number = 0;
        });
    },
    navigateToFileUpload() {
      this.$store.commit("setLotIds", {
        lotIds: this.headerText,
        inventoryId: "Approval Matrix",
        action: 'first_tab'
      });
      this.$router.push({ name: "LotFileuploadComm" });
    },
  }
};
</script>
<style scoped>
.item-selected {
  margin-top: 23px;
  position: absolute;
  left: 41%;
}

@media (max-height: 1104px) {
  .PaddingItemPerPage {
    padding: 8px !important;
  }
}

@media (min-height: 1126px) {
  .PaddingItemPerPage {
    padding: 24px !important;
  }
}

.v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 283px) !important;
}
</style>